// 跳转新窗口方式打开网址<兼容ios>
export const jumpUrlNewWindow = (url) => {
  let dom = document.createElement('a');
  dom.setAttribute('href', url);
  dom.setAttribute('target', '_blank');
  document.body.appendChild(dom);
  dom.click();
  document.body.removeChild(dom);
}